@if (offer(); as offer) {
  @if (variant() === 'card') {
    <div class="order-overview-ed__card card rounded">
      <div class="card-body p-2">
        <div class="d-flex justify-content-between align-items-center">
          <p class="h4 text-break mb-0">
            @if (content().enableNewOfferCardTitles) {
              {{ offer.productTitle }} - {{ offer.durationTitle }}
            } @else {
              {{ offer.productTitle }}
            }
          </p>
          @if (content().showEditButton) {
            <wl-offer-overview-change-offer
              [rendering]="rendering()"
              class="ms-1"
            ></wl-offer-overview-change-offer>
          }
        </div>
        <ng-container
          *ngTemplateOutlet="body; context: { offer, variant: variant() }"
        ></ng-container>
      </div>
    </div>
  } @else if (variant() === 'accordion') {
    <div ngbAccordion class="accordion order-overview-ed__accordion">
      <div
        ngbAccordionItem
        [collapsed]="deviceInfo().isMobile"
        class="accordion-item"
      >
        <div ngbAccordionHeader>
          <button
            ngbAccordionButton
            class="accordion-button accordion-button--no-icon align-items-start"
          >
            <div class="d-flex flex-column gap-2 w-100">
              <p class="h4 text-break mb-0" wlCSCapture>
                @if (content().enableNewOfferCardTitles) {
                  {{ offer?.productTitle }} - {{ offer?.durationTitle }}
                } @else {
                  {{ offer?.productTitle }}
                }
              </p>

              <div class="costs-in-header">
                <span>{{ content().monthlyAmountLabel }}</span>
                <span class="h4 text-brand">{{
                  offer?.expectedMonthlyAmount
                    ? (offer.expectedMonthlyAmount.toString() | roundedCurrency)
                    : ''
                }}</span>
              </div>
            </div>
          </button>
        </div>

        <div ngbAccordionCollapse>
          <div ngbAccordionBody class="accordion-body">
            <ng-container
              *ngTemplateOutlet="body; context: { offer, variant: variant() }"
            ></ng-container>
          </div>
        </div>
      </div>
    </div>

    @if (content().orderFootnote) {
      <wl-rich-text-wrapper
        [field]="{ value: content().orderFootnote }"
        class="d-block mt-3"
      >
        <div class="vertical-list"></div>
      </wl-rich-text-wrapper>
    }
  }
} @else {
  <wl-svg-skeleton-loader [mask]="skeletonLoaderMask()" />
}

<ng-template #body let-offer="offer" let-variant="variant">
  <p
    class="mb-0"
    [class.mt-3]="variant === 'card'"
    *scText="{ value: content().summaryCalculationBasedOn }"
  ></p>
  @if (consumptionValuesVM(); as consumptionValues) {
    <wl-order-overview-consumption
      class
      [consumptionValues]="consumptionValues"
    ></wl-order-overview-consumption>
  }
  <hr />
  @if (variant === 'card') {
    <wl-order-overview-budget-bill
      [beforeDiscountYearlyLabel]="{
        value: content().beforeDiscountExpectedYearlyLabel,
      }"
      [beforeDiscountYearlyAmount]="offer.beforeDiscountExpectedYearlyAmount"
      [cashbackAmount]="offer.discountPrice"
      [cashbackLabel]="{ value: content().incentiveLabel }"
      [yearlyLabel]="yearlyCostLabel()"
      [yearlyAmount]="offer.expectedYearlyAmount"
      [monthlyAmount]="offer.expectedMonthlyAmount"
      [monthlyAmountLabel]="{ value: content().monthlyAmountLabel }"
      [monthlyAmountTooltip]="content().monthlyAmountTooltip"
      [monthlyAmountAdditionalLabel]="content().monthlyAmountAdditionalLabel"
      [budgetBillAmount]="offer.budgetBillAmount"
      [budgetBillLabel]="{ value: content().budgetBillSuggestion }"
      [budgetBillTooltip]="content().budgetBillSuggestionTooltip"
      [hideAnnualCosts]="content().hideAnnualCosts"
      [costsWithDiscountLabel]="content().costsWithDiscountLabel"
      [termijnbedragVariantA]="!!termijnbedragVariantA()"
      [termijnbedragVariantB]="!!termijnbedragVariantB()"
      [enableRemoveBBA]="getFieldValueBBAFeatureFlag()"
    />
  } @else if (variant === 'accordion') {
    @if (offer.discountPrice) {
      <div class="d-flex justify-content-between mb-1">
        <span wlCSCapture>{{
          content().beforeDiscountExpectedYearlyLabel
        }}</span>
        <span wlCSCapture>
          {{ offer.beforeDiscountExpectedYearlyAmount | roundedCurrency }}
        </span>
      </div>

      <div class="d-flex justify-content-between text-success mb-1 fw-bold">
        <span wlCSCapture> {{ content().incentiveLabel }}</span>
        <span wlCSCapture class="flex-shrink-0">
          -&nbsp;{{ offer.discountPrice | roundedCurrency }}
        </span>
      </div>
    }

    <div class="d-flex justify-content-between fw-bold mb-1">
      <span wlCSCapture>{{ yearlyCostLabel() }}</span>
      <span wlCSCapture>
        {{ offer.expectedYearlyAmount | roundedCurrency }}
      </span>
    </div>
  }
  @if (displayMGM()) {
    <div class="order-overview-ed__mgm-badge">
      {{
        content().mgmSharedValueText
          | interpolate
            : {
                variables: {
                  mgmValue: mgmSharedValue() | roundedCurrency,
                },
              }
      }}
    </div>
  }
  <hr />
  <div>
    <div class="d-flex mb-3 mt-3 justify-content-center">
      <button
        class="p-0 btn btn-link text-primary"
        [wlTrackLink]="
          !!getFieldValueBBAFeatureFlag()
            ? content().AOMModalLinkTextNoBBA
            : content().AOMModalLinkText
        "
        [trackLinkInfo]="{
          type: 'button',
          rendering: {
            componentName: 'product detail',
          },
          field: !!getFieldValueBBAFeatureFlag()
            ? content().AOMModalLinkTextNoBBA
            : content().AOMModalLinkText,
          eventType: 'link-click',
        }"
        wlAutomationId="show-tariffs"
        (click)="showTariffs.emit(offer)"
        *scText="{
          value: !!getFieldValueBBAFeatureFlag()
            ? content().AOMModalLinkTextNoBBA
            : content().AOMModalLinkText,
        }"
      ></button>
      @if (content().AOMmodalTooltip) {
        <span class="d-flex align-items-center ps-2">
          <wl-tooltip
            [tooltip]="{
              description: content().AOMmodalTooltip,
            }"
          ></wl-tooltip>
        </span>
      }
    </div>
    @if (variant === 'card' && usps().length) {
      <div>
        <div class="rounded p-2 order-overview-ed__usps">
          @if (usps(); as usps) {
            <wl-offer-usps [usps]="usps"></wl-offer-usps>
          }
        </div>
      </div>
    }
  </div>
</ng-template>
